import { assign, createMachine } from "xstate";
import { IMobileOrchestrator } from "@nju/data-access-portal-orchestrator";

export type ISelectedMsisdnOfferType = "PREPAID" | "POSTPAID";

interface IContext {
  selectedMsisdnOfferType?: ISelectedMsisdnOfferType;
  errorMessage?: string;
}

type IEvent =
  | { type: "SET_MSISDN_OFFER_TYPE"; value: ISelectedMsisdnOfferType }
  | { type: "SUBMIT" }
  | { type: "SUCCESS"; value: IMobileOrchestrator }
  | { type: "FAILED" };

export const selectMsisdnOfferTypeMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        on: {
          SET_MSISDN_OFFER_TYPE: {
            actions: "setMsisdnOfferType",
          },
          SUBMIT: [
            {
              cond: "isPrepaidSelected",
              actions: "redirectToPrepaidOfferMigrationPage",
              target: "goToNextStep",
            },
            {
              cond: "isPostpaidSelected",
              actions: "redirectToPostpaidOfferMigrationPage",
              target: "goToNextStep",
            },
            {
              actions: "setErrorMessage",
            },
          ],
        },
      },
      goToNextStep: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setMsisdnOfferType: assign((context, event: IEvent) => {
        if (event.type === "SET_MSISDN_OFFER_TYPE") {
          return {
            selectedMsisdnOfferType: event.value,
            errorMessage: undefined,
          };
        }

        return context;
      }),
      setErrorMessage: assign((_, __: IEvent) => {
        return {
          errorMessage: "Aby przejść dalej, wybierz typ oferty.",
        };
      }),
    },
    guards: {
      isPrepaidSelected: ({ selectedMsisdnOfferType }) => {
        return selectedMsisdnOfferType === "PREPAID";
      },
      isPostpaidSelected: ({ selectedMsisdnOfferType }) => {
        return selectedMsisdnOfferType === "POSTPAID";
      },
    },
  },
);
